import React, { Component } from 'react';
import PropTypes from "prop-types";
import Layout from '../../../Layouts/DefaultLayout';
import * as PostActions from '../../../../redux/post/actions';
import OfferingResCarousel from '../../../Layouts/Partials/OfferingResCarousel';
import OtherOfferingsCarousel from '../../../Layouts/Partials/OtherOfferingsCarousel';
import { Row, Col, Badge, Image, Container,Breadcrumb } from 'react-bootstrap';
import DefaultAvatar from '../../../Styles/image/AVATAR.png';
import Slider from "react-slick";
const _ = require('lodash');


class OfferingViewContainer extends Component {
    static contextTypes = {
        router: PropTypes.object,
    };

    constructor(props) {
        super();
        this.state = {
            data: null,
            data_readmore:[],
            industry:null,
            isLoading: false,
            index: 0,
            direction: null,
        }
    }

    componentWillMount = async () => {


        this._handleScreen();
    }


    shouldComponentUpdate(nextProps, nextState) {

        return true;
    }

    _handleScreen = async () => {
        let slug = this.props.match.params.slug;
        if (slug !== null && slug !== undefined) {
            this.setState({ isLoading: true });
            let resp = await PostActions.getOfferingJSON(this.props.token, slug, process.env.REACT_APP_MODE);
            if (resp.status) {

                this.setState({ data: resp.data }, () => {
                    this.setState({ isLoading: false });

                    let industry=(resp.data.industries.length>0?resp.data.industries[0]:null);
                    this._handleReadMore(resp.data.ID,industry );
                });
            } else {
                this.backToList();
            }
        } else {
            this.backToList();
        }
    }

    backToList = () => {
       this.props.history.push(`/offerings`);
    }

    _handleReadMore = async (postid,industry) => {

        this.setState({ isLoading: true });

        let reqobj = {};
        reqobj['env'] = process.env.REACT_APP_MODE;
        reqobj['posts_per_page'] = 4;
        reqobj['postid_except'] = postid;
        reqobj['post-type'] = 'offering';

        if(industry!==null){
            reqobj['industries']=[industry['term_id']]
        }

        let resp = await PostActions.getAnyPostsJSON(this.props.token, 1, reqobj);

        if (resp.status) {
            this.setState({ data_readmore: resp.data.data,industry:industry }, () => {
                this.setState({ isLoading: false })
            });
        } else {
            this.setState({ isLoading: false })
        }

    }

    render = () => {
        let data = this.state.data;
        let datareadmore=this.state.data_readmore;
        let isLoading = this.state.isLoading;
        
        document.title = `Bridge Alliance | ${data ? data.post_title : ""}`

        return (
            <Layout>
                    {(isLoading) && (
                        <div className="p-5 text-center">
                            <div className="spinner-border text-secondary" role="status">
                                <span className="sr-only">Loading...</span>
                            </div>
                        </div>
                    )}
                    {(isLoading === false && data !== null) && (
                        <React.Fragment>
                            <Container>
                            <Row>
                                <Col>
                                    {this._renderHeader(data)}
                                </Col>
                            </Row>
                            <Row>
                                <Col md={12}>
                                    {this._renderSlider(data.headermedia === false ? [] : data.headermedia)}
                                </Col>
                            </Row>

                            {/*Comments: commented for 5G Resources-Download Alignment changes, Modified By: <Asar>, Date Modified: <2020-01-29>

                            <Row className="py-5">
                                <Col md={{ span: 8, offset: 2 }}>
                                    {this._renderBody(data.post_content)}
                                </Col>
                            </Row>

                             
                            <Row className="py-3">
                                <Col md={{ span: 6, offset: 3 }}>
                                    {this._renderFooter(data)}
                                </Col>
                            </Row>
                           
                            <Row>
                                <Col>
                                    {this._renderFooterSlider(data.resources, (data.bmos.length > 0 ? data.bmos[0].name : ""))}
                                </Col>
                            </Row>
                            */}

                            {/*Comments: 5G Resources-Download Alignment changes , Modified By: <Asar>, Date Modified: <2020-01-29>*/}
                            
                            <Row className="py-5">
                                <Col md={{ span: 12, offset: 0 }}>  {/* Card detail layout changes- changed md from 8 to 12 */}
                                    {this._renderBody(data.post_content)}
                                </Col>
                            </Row>

                            <Row className="py-3">
                                <Col md={{ span: 6, offset: 0 }} align="center">  {/* Card detail layout changes - added align center */}
                                    {this._renderFooter(data)}
                                </Col>
                                <Col md={{ span: 6, offset: 0 }}>
                                    {this._renderFooterSlider(data.resources, (data.bmos.length > 0 ? data.bmos[0].name : ""))}
                                </Col>
                            </Row>
                            {/*Comments: 5G Resources-Download Alignment changes , Modified By: <Asar>, Date Modified: <2020-01-29>*/}
                            
                            </Container>
                            {this._renderReadMore(datareadmore)}
                        </React.Fragment>
                    )}
            </Layout>
        );
    };


    _renderReadMore = (data) => {
        let industry=this.state.industry;
        return(
         <OtherOfferingsCarousel data={data} industry={(industry!==null?industry.name:"")}/>
        )
    }

    _renderHeader = (data) => {
        const monthNames = ["January", "February", "March", "April", "May", "June",
            "July", "August", "September", "October", "November", "December"
        ];
        let postdate = new Date(data.post_date);
        let formatted_date = postdate.getDate() + " " + monthNames[postdate.getMonth()] + " " + postdate.getFullYear()
        return (
            <React.Fragment>
                {/*
                <Breadcrumb className="mt-4">
                    <Breadcrumb.Item href="/offerings">Verticals</Breadcrumb.Item>
                    <Breadcrumb.Item>{data.post_title}</Breadcrumb.Item>
                </Breadcrumb>
                */}
                <h1>{`${data.post_title}`}</h1>
                {(data.post_status === "pending") && (
                    <Badge variant="warning">{`Pending`}</Badge>
                )}
                <Row className="mb-4">
                    <Col md={7}>
                        <span>
                            {`${(data.industries.length > 0 ? _.unescape(data.industries[0].name) : "")} | ${(data.bmos.length > 0 ? _.unescape(data.bmos[0].name) : "")} | ${formatted_date}  `}
                        </span>
                    </Col>
                    <Col md={5} className="text-right">
                        {data.tags.map((v, i) => (
                            <a href={`/search?tag=${v.slug}`}>
                            <span key={`span_${i}`}>
                                {(i > 0) && (`| #${v.name} `)}{(i === 0) && (`#${v.name} `)}
                            </span>
                            </a>
                           
                        ))}
                    </Col>
                </Row>
            </React.Fragment>
        );
    }

    handleSelect = (selectedIndex, e) => {
        this.setState({
            index: selectedIndex,
            direction: e.direction,
        });
    }

    _renderSlider = (items) => {
        const { index, direction } = this.state;
        return (
            <Slider
                activeIndex={index}
                direction={direction}
                onSelect={this.handleSelect}
            >
                {items.map((item, key) => {
                    return (
                        <div key={key}>
                            <img
                                alt=""
                                className="img-fluid"
                                src={item.sizes['offering-header']}
                            />
                        </div>
                    )
                })}


            </Slider>
        );
    }
    /** end: slider */

    /** start: body */
    _renderBody = (data) => {        
        let res = data.replace(/oembed url="https:\/\/www\.youtube\.com\/watch\?v=/g, function($1, $2) {
            return "iframe width=\"560\" height=\"315\" src=\"https://www.youtube.com/embed/"
        })

        /* Code for Vimeo Video display */
        res = res.replace(/oembed url="https:\/\/vimeo\.com\//g, function($1, $2) {
            return "iframe width=\"560\" height=\"315\"  allow=\"autoplay; \" src=\"https://player.vimeo.com/video/"
        })

        res = res.replace(/oembed/g, 'iframe')
        console.log(res)
        return (
            <div dangerouslySetInnerHTML={{ __html: res }}></div>
        )
    }
    /** end: body */

    _renderFooterSlider = (data, bmo) => {
        if (data === false) {
            return (null);
        }
        return (
            <React.Fragment>
                {/*<hr/>*/}  {/*Comments: 5G Resources-Download Alignment changes , Modified By: <Asar>, Date Modified: <2020-01-29>*/}
                <OfferingResCarousel data={data} bmoname={bmo}/>
            </React.Fragment>
        );
    }

    _renderFooter = (data) => {
        return (
            <React.Fragment >
                <h4 className="mb-4">Speak to us for more information</h4>
                <Container>
                    <Row>
                        <Col sm="4"></Col>                              {/* Card detail layout changes */}
                        <Col xs={6} md={4}>
                            <Image
                                src={data.contact_photo === false ? DefaultAvatar : ""}
                                roundedCircle
                                thumbnail
                            />
                        </Col>
                    </Row>
                   
                    <Row>
                    <Col sm="2"></Col>                              {/* Card detail layout changes */}
                    <Col xs={6} md={8}>
                            <strong>{`${data.contact_fname} ${data.contact_lname}`}</strong>
                            <p>{data.contact_email}</p>
                            <p>{data.conatct_phone}</p>
                            {(data.website !== null && data.website !== "") && (
                                <p><strong>Website:</strong><a href={data.website}>{data.website}</a></p>
                            )}

                        </Col>
                    </Row>
                </Container>
            </React.Fragment>
        );
    }

    /*
    _renderFooter = (data) => {
        return (
            <React.Fragment >
                <h4 className="mb-4">Speak to Us for more information</h4>
                <Container>
                    <Row>
                        <Col xs={6} md={4}>
                            <Image
                                src={data.contact_photo === false ? DefaultAvatar : ""}
                                roundedCircle
                                thumbnail
                            />
                        </Col>
                        <Col xs={6} md={8}>
                            <strong>{`${data.contact_fname} ${data.contact_lname}`}</strong>
                            <p>{data.contact_email}</p>
                            <p>{data.conatct_phone}</p>
                            {(data.website !== null && data.website !== "") && (
                                <p><strong>Website:</strong><a href={data.website}>{data.website}</a></p>
                            )}

                        </Col>
                    </Row>
                </Container>
            </React.Fragment>
        );
    }
    */

}


/* Export Component ==================================================================== */
export default OfferingViewContainer;